import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

export const isUnauthorized = (error: HttpErrorResponse): boolean => {
  return error.status === HttpStatusCode.Unauthorized;
};
